import { Room, TwilioError } from 'twilio-video';
import { useEffect } from 'react';

// eslint-disable-next-line import/no-default-export
export default function useHandleRoomDisconnection(
  room: Room | null,
  onError: (...args: any[]) => void,
  removeLocalAudioTrack: () => void,
  removeLocalVideoTrack: () => void,
  isSharingScreen: boolean,
  toggleScreenShare: () => void,
  isVideoFilterEnabled: boolean,
  toggleVideoFilter: (reset?: boolean) => void,
) {
  useEffect(() => {
    if (room) {
      const onDisconnected = (_: Room, error: TwilioError) => {
        if (error) {
          onError(error);
        }

        removeLocalAudioTrack();
        removeLocalVideoTrack();

        if (isSharingScreen) {
          toggleScreenShare();
        }

        if (isVideoFilterEnabled) {
          toggleVideoFilter(true);
        }
      };

      room.on('disconnected', onDisconnected);
      return () => {
        room.off('disconnected', onDisconnected);
      };
    }
  }, [ room, onError, removeLocalAudioTrack, removeLocalVideoTrack, isSharingScreen, toggleScreenShare, isVideoFilterEnabled, toggleVideoFilter ]);
}
